module.exports = __webpack_public_path__ + "annotation_24x24.png?2e5aa8ad8b45483b8355cffef69c7258";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/annotation_24x24.png
// module id = 1038
// module chunks = 0